import { AppHelper } from "../../appHelper.js";
import { Config } from "../config/config.js";
import { Helper } from "../util/helper.js"
import { HTTPService, JsonResultClass } from "../util/httpManager.js"
import { NotificationHelper } from "../util/notificationHelper.js"
import { Grid } from "./grid.js";
import { Dialog, DialogProps } from "./dialog.js";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "./toolBar.js";
import { AppBaseProps, CommonApp, Entity, Metadata } from './commonApp.js'
import { General } from "../../../siteManagement/general.js";
import { SheetEventType } from "../../../siteManagement/sheet.js";
import { DialogHelper } from "../util/dialogHelper.js";
import { ComponentHelper } from "../util/componentHelper.js";
import { DropDownList } from "./dropDownList.js";
import { BaseField } from "./baseComponentProps.js";
import React from "react"
import ReactDOM from "react-dom";

export class EditNachschlag extends React.Component<EditNachschlagProps, { data: any[] }> {
    private gridOptions: kendo.ui.GridOptions;
    private standardButtons: Array<ToolBarStandardButton> = [
        { type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: true },
        { type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: true },
        { type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: true }
    ];
    private metaData: Metadata;
    private url = "EditNachschlag/";
    private maingroupRightsActive: boolean;

    constructor(props) {
        super(props)
        this.url += this.props.field.tabId + "/";
        this.state = {
            data: []
        };
        this.initApp();
    }

    private initApp = async () => {
        this.gridOptions = {
            sortable: true,
            pageable: false,
            groupable: false,
            filterable: false,
            selectable: true,
            resizable: true,
            scrollable: true,
            editable: false,
            columns: [
                {
                    field: "Id",
                    title: Helper.getTranslation("Standard.Key"),
                },
                {
                    field: "DisplayName",
                    title: Helper.getTranslation("Standard.Bezeichnung"),
                }
            ]
        };
        const [data, metaData] = await Promise.all([
            this.loadData(),
            Helper.getMetaData(Helper.isNullOrEmpty(this.props.field.formConfig) ? "editNachschlag" : this.props.field.formConfig)
        ]);
        if (Helper.hasValue(this.props.field.helpguid)) {
            metaData.rightDrawerContainer.multipleComponents[0].props.url = metaData.rightDrawerContainer.multipleComponents[0].props.url.replace("{{helpguid}}", this.props.field.helpguid)
        }

        this.metaData = metaData;
        this.setState({ data: data })
    }

    private loadData = async () => {
        const result = await HTTPService.get<JsonResultClass<[]>>(`${this.url}GetAll`);
        if (result.Code != 0) {
            NotificationHelper.showErrorMessage(result.Message);
            return [];
        }
        this.maingroupRightsActive = result.AdditionalData["MaingroupRightsActive"];
        return result.Data;
    }

    private onStandardClick = async (type: ToolBarStandardButtonType, item: { Id: string }) => {
        switch (type) {
            case ToolBarStandardButtonType.EDIT:
                const result = await HTTPService.get<JsonResultClass<NachschlagEntity>>(`${this.url}GetById?id=${item.Id}`)
                if (result.Code == 0) {
                    this.openSheet(result.Data);
                }
                break;
            case ToolBarStandardButtonType.NEW:
                this.openSheet({
                    Id: null,
                    IsNew: true,
                    IsWatchable: false,
                    IsWatched: false,
                    RecordRight: {
                        CanRead: true,
                        CanWrite: true
                    },
                    IndividualFields: {},
                    Translations: [],
                    MainGroupAffiliation: []
                });
                break;
            case ToolBarStandardButtonType.DELETE:
                const isOk = await this.delete(item.Id);
                if (isOk) {
                    const data = await this.loadData();
                    this.setState({ data: data })
                }
                break;
        }
    }

    private openSheet = (entity: NachschlagEntity) => {
        const props: NachschlagSheetProps = {
            context: { key1: "entity.Id", keyVal1: entity.Id, contextType: "editNachschlag" },
            title: this.props.field.title,
            entity: entity,
            metadata: this.metaData,
            dataSources: {},
            isWindow: true,
            tabId: this.props.field.tabId,
            delete: this.delete,
            maingroupRightsActive: this.maingroupRightsActive,
        };
        const sheet = General.Sheet.Manager.createSheet();
        sheet.bind(SheetEventType.Close, async () => {
            const data = await this.loadData();
            this.setState({ data: data })
        });

        sheet.show(() => {
            sheet.mountContent(NachschlagSheet, props);
        });
    }

    private delete = async (id: string) => {
        const isOk = await DialogHelper.confirm(Helper.getTranslation("Standard.Msg.Loeschen"));
        if (!isOk)
            return false;
        const result = await HTTPService.get<JsonResultClass<NachschlagEntity>>(`${this.url}Delete?id=${id}`);
        if (result.Code != 0) {
            NotificationHelper.showErrorMessage(result.Message);
        }
        return result.Code == 0;
    }

    render() {
        return (
            <div className="flex-container">
                <Grid
                    data={this.state.data}
                    options={this.gridOptions}
                    id={`nachschlag__${this.props.field.tabId}`}
                    standardButtons={this.standardButtons}
                    onClickStandardButton={this.onStandardClick}
                />
            </div>
        );
    }
}

interface EditNachschlagField extends BaseField {
    tabId: 30;
    formConfig: string;
    helpguid?: string;
    title?: string;
}

interface EditNachschlagProps {
    field: EditNachschlagField
}

class NachschlagSheet extends React.Component<NachschlagSheetProps, any>{
    private common = new AppHelper();
    tabId: number;
    maingroupRightsActive: boolean;
    constructor(props) {
        super(props)
        this.maingroupRightsActive = this.props.maingroupRightsActive;
        this.tabId = this.props.tabId;
        this.common.enableHooks = true;
        this.common.init(this);
    }

    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {

        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    remove = async () => {
        const isOk = await this.props.delete(this.props.entity.Id);
        if (isOk) {
            General.Sheet.Manager.getTopMostVisibleSheet().hide();
        }
    }

    private validate = () => {
        if (!this.common.validate())
            return false

        const translations = this.props.entity.Translations.filter(item => !Helper.isNullOrEmpty(item.Value));
        if (translations.length == 0) {
            NotificationHelper.showWarningMessage(Helper.getTranslation("WebSMS.Report.Question.Messages.TitlesNotTranslated"));
            return false;
        }

        if (this.maingroupRightsActive && this.props.entity.MainGroupAffiliation.length == 0) {
            NotificationHelper.showWarningMessage(Helper.getTranslation("WebSMS.GeneralSettings.MindestensEineObergruppe"));
            return false;
        }


        return true;
    }

    save = async () => {
        if (this.validate()) {
            const result = await HTTPService.post<JsonResultClass>(`EditNachschlag/${this.props.tabId}/Save`, {
                model: this.props.entity
            });
            if (result.Code === 0) {
                this.props.entity.IsNew = false;
                NotificationHelper.showSuccessMessage(Helper.getTranslation("Standard.Msg.SpeichernErfolgreich"));
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
            this.common.handlePostSave(result.Code === 0);
            this.setState({});
        }
    }

    renderGrid = () => {
        return (
            <>
                <MainGroupList values={this.props.entity.MainGroupAffiliation} onChange={(values) => { this.handleFieldChange({ model: "entity.MainGroupAffiliation" }, values.sort()) }} />
            </>
        );
    }

    componentDidMount() {
        this.common.updateSheetTitle(Helper.isNullOrEmpty(this.props.title) ? "" : this.props.title);
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common, handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}

interface NachschlagSheetProps extends AppBaseProps {
    tabId: number;
    entity: NachschlagEntity;
    delete: (id) => Promise<boolean>;
    maingroupRightsActive: boolean;
    title?: string;
}

interface NachschlagEntity extends Entity {
    Id: string;
    Translations: any[];
    MainGroupAffiliation: number[];
}

class MainGroupList extends React.Component<{ values: number[], onChange: (values: number[]) => void }, any>{
    private maingroups: { key, value }[] = [];
    private gridOptions: kendo.ui.GridOptions;

    constructor(props) {
        super(props)
        this.initApp();
    }

    private initApp = async () => {
        const result = await HTTPService.get<JsonResultClass>("GeneralSettings/GetGridData?context=maingroups");
        this.maingroups = result.Data;
        this.gridOptions = {
            sortable: true,
            pageable: false,
            groupable: false,
            filterable: false,
            selectable: true,
            resizable: true,
            scrollable: true,
            editable: false,
            columns: [
                {
                    title: Helper.getTranslation("Field.Adresse.ogrnr"),
                    template: (value) => {
                        const item = this.maingroups.find(f => f.key == value)
                        return item.value;
                    }
                }
            ]
        };


        this.setState({})
    }

    private onStandardClick = async (type: ToolBarStandardButtonType, value: any) => {
        let values = this.props.values;
        switch (type) {
            case ToolBarStandardButtonType.NEW:
                const ogrNr = await openMainGroupDialog(this.maingroups.filter(mg => values.findIndex(v => v == mg.key) == -1));
                if (Helper.hasValue(ogrNr)) {
                    values.push(ogrNr)
                }
                break;
            case ToolBarStandardButtonType.DELETE:
                values = values.filter(ogrNr => ogrNr != value)
                break;
        }
        values = [...new Set(values)] as number[];
        this.props.onChange(values);
    }

    render() {
        if (!Helper.hasValue(this.gridOptions))
            return null;

        const standardButtons: Array<ToolBarStandardButton> = [
            { type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: this.props.values.length != this.maingroups.length },
            { type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: true }
        ];

        return (
            <div className="flex-container">
                <Grid
                    data={this.props.values}
                    options={this.gridOptions}
                    id={`nachschlag__maingroups`}
                    standardButtons={standardButtons}
                    onClickStandardButton={this.onStandardClick}
                />
            </div>
        );

    }
}

const openMainGroupDialog = (dataSource: any[]) => {
    return new Promise<number>((resolve) => {
        var value = dataSource[0].key;


        const props = ComponentHelper.createFactory().getDefaultDropDownProps();
        props.dataSource = dataSource;
        props.value = value;
        props.field.dataTextField = "value";
        props.field.dataValueField = "key";
        props.onChange = (_, newValue) => {
            value = newValue;
        }

        const targetElement = $("<div>");
        $("body").append(targetElement);

        const dialogProps: DialogProps = {
            actions: [
                {
                    label: Config.translations.cancel,
                    action: () => {
                        resolve(null)
                    }
                },
                {
                    label: Config.translations.ok,
                    action: () => {
                        resolve(value)
                    },
                    primary: true
                }
            ],
            title: Helper.getTranslation("Field.Einsatz.ogrnr"),
            width: "500px"
        }

        ReactDOM.render(
            <Dialog {...dialogProps} open={true}>
                <DropDownList {...props} />
            </Dialog >, targetElement[0]);


    })
}